import { remove as removeAccents } from 'remove-accents';

/**
 * Normalizes string by:
 * - replacing accents from regular latin charactes,
 * - removes special characters except space,
 * - converts all characters to lower case variant.
 * - trim string
 *
 * @param string
 */
export const normalizeString = (string: string) => {
  return removeAccents(string)
    .replace(/[^A-Za-z0-9 ]/g, '')
    .toLowerCase()
    .trim();
};
